import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import { getCompanyKnowledgeGuide, getKnowledgeGuideLinks } from 'store/actions';

const CompanyKnowledgeGuide = () => {
    const dispatch = useDispatch();
    const [finalCompanyLinks, setFinalCompanyLinks] = useState([]);
    const lobCategories = ["Health", "Motor", "Travel", "Non_Motor_Non_Health"];
    const { companyList, companyWiseLinks, errors, successMsg, Loading } = useSelector(state => state.MainKnowledgeCenterReducer)


    function transformData(companyList, knowledgeGuide) {
        // Create a map to store the transformed data
        let transformedData = [];

        // Iterate through the company list
        companyList.forEach(company => {
            // Create a temporary company object
            let tempCompany = {
                company_id: company.company_id,
                company_name: company.name,
                Health: {
                    policy_link: "",
                    brouchere_link: "",
                    proposal_link: "",
                    claim_link: ""
                },
                Motor: {
                    policy_link: "",
                    brouchere_link: "",
                    proposal_link: "",
                    claim_link: ""
                },
                "Non_Motor_Non_Health": {
                    policy_link: "",
                    brouchere_link: "",
                    proposal_link: "",
                    claim_link: ""
                },
                Travel: {
                    policy_link: "",
                    brouchere_link: "",
                    proposal_link: "",
                    claim_link: ""
                }
            };

            // Iterate through the knowledge guide to find matching company_id and LOB
            knowledgeGuide.forEach(guide => {
                if (guide.company_id === company.company_id) {
                    switch (guide.LOB) {
                        case "Health":
                            tempCompany.Health.policy_link = guide.policy_link;
                            tempCompany.Health.brouchere_link = guide.brouchere_link;
                            tempCompany.Health.proposal_link = guide.proposal_link;
                            tempCompany.Health.claim_link = guide.claim_link;
                            break;
                        case "Motor":
                            tempCompany.Motor.policy_link = guide.policy_link;
                            tempCompany.Motor.brouchere_link = guide.brouchere_link;
                            tempCompany.Motor.proposal_link = guide.proposal_link;
                            tempCompany.Motor.claim_link = guide.claim_link;
                            break;
                        case "Non Motor Non Health":
                            tempCompany.Non_Motor_Non_Health.policy_link = guide.policy_link;
                            tempCompany.Non_Motor_Non_Health.brouchere_link = guide.brouchere_link;
                            tempCompany.Non_Motor_Non_Health.proposal_link = guide.proposal_link;
                            tempCompany.Non_Motor_Non_Health.claim_link = guide.claim_link;
                            break;
                        case "Travel":
                            tempCompany.Travel.policy_link = guide.policy_link;
                            tempCompany.Travel.brouchere_link = guide.brouchere_link;
                            tempCompany.Travel.proposal_link = guide.proposal_link;
                            tempCompany.Travel.claim_link = guide.claim_link;
                            break;
                        default:
                            break;
                    }
                }
            });

            // Add the transformed company object to the array
            transformedData.push(tempCompany);
        });
        setFinalCompanyLinks(transformedData)
        // return transformedData;
    }


    useEffect(() => {
        if (companyList && companyWiseLinks && companyList.length > 0 && companyWiseLinks.length > 0) {
            transformData(companyList, companyWiseLinks);
        }
    }, [companyList, companyWiseLinks])

    useEffect(() => {
        dispatch(getCompanyKnowledgeGuide())
    }, [])

    useEffect(() => {
        if (companyList && companyList.length > 0) {
            dispatch(getKnowledgeGuideLinks())
        }
    }, [companyList])

    useEffect(() => {
        console.log(finalCompanyLinks)
    }, [finalCompanyLinks])


    return (
        <div className='page-content'>
            <div className='bg-white p-3'>
                <div>
                    <h2>Company Knowledge Guide</h2>
                </div>

                {/* <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                        <thead className="table-dark">
                            <tr>
                                <th>#</th>
                                <th>Company Name</th>
                                <th>LOB</th>
                                <th>Policy Links</th>
                                <th>Brochure Links</th>
                                <th>Proposal Links</th>
                                <th>Claim Links</th>
                            </tr>
                        </thead>
                        <tbody>
                            {finalCompanyLinks.map((company, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{company.company_name}</td>
                                    <td>
                                        {lobCategories.map((lob, i) => (
                                            <div key={i} className="mb-1">{lob.replace(/_/g, " ")}</div>
                                        ))}
                                    </td>
                                    {["policy_link", "brouchere_link", "proposal_link", "claim_link"].map((linkType, colIndex) => (
                                        <td key={colIndex}>
                                            {lobCategories.map((lob, i) => (
                                                <div key={i} className="d-flex align-items-center mb-1">
                                                    {company[lob]?.[linkType] && company[lob]?.[linkType] !== "NA" ? (
                                                        <Link to={company[lob][linkType]} className="text-primary ms-2" target='_blank'>Click to Open</Link>
                                                    ) : (
                                                        <span className="text-danger ms-2">N/A</span>
                                                    )}
                                                </div>
                                            ))}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div> */}

                <div className='table-responsive'>
                    <table className='table table-bordered table-striped table-hover'>

                        <thead className="table-dark">
                            <tr>
                                <th>#</th>
                                <th>Company Name</th>
                                <th>LOB</th>
                                <th>Policy Links</th>
                                <th>Brochure Links</th>
                                <th>Proposal Links</th>
                                <th>Claim Links</th>
                            </tr>
                        </thead>

                        {
                            finalCompanyLinks.map((company, index) => (
                                <tbody key={index} className='border border-dark'>
                                    <tr>
                                        <td rowSpan={5}>{index + 1}</td>
                                        <td rowSpan={5} className=''>
                                            <b>{company.company_name}</b>
                                        </td>
                                    </tr>
                                    <tr className='bg-danger'>
                                        <td>Health</td>
                                        <td>{company.Health.policy_link && company.Health.policy_link !== "NA" ? <a href={company.Health.policy_link} target="_black">Click here</a> : "NA"}</td>
                                        <td>{company.Health.brouchere_link && company.Health.brouchere_link !== "NA" ? <a href={company.Health.brouchere_link} target="_black">Click here</a> : "NA"}</td>
                                        <td>{company.Health.proposal_link && company.Health.proposal_link !== "NA" ? <a href={company.Health.proposal_link} target="_black">Click here</a> : "NA"}</td>
                                        <td>{company.Health.claim_link && company.Health.claim_link !== "NA" ? <a href={company.Health.claim_link} target="_black">Click here</a> : "NA"}</td>
                                    </tr>
                                    <tr>
                                        <td>Motor</td>
                                        <td>{company.Motor.policy_link && company.Motor.policy_link !== "NA" ? <a href={company.Motor.policy_link} target="_black">Click here</a> : "NA"}</td>
                                        <td>{company.Motor.brouchere_link && company.Motor.brouchere_link !== "NA" ? <a href={company.Motor.brouchere_link} target="_black">Click here</a> : "NA"}</td>
                                        <td>{company.Motor.proposal_link && company.Motor.proposal_link !== "NA" ? <a href={company.Motor.proposal_link} target="_black">Click here</a> : "NA"}</td>
                                        <td>{company.Motor.claim_link && company.Motor.claim_link !== "NA" ? <a href={company.Motor.claim_link} target="_black">Click here</a> : "NA"}</td>
                                    </tr>
                                    <tr>
                                        <td>Travel</td>
                                        <td>{company.Travel.policy_link && company.Travel.policy_link !== "NA" ? <a href={company.Travel.policy_link} target="_black">Click here</a> : "NA"}</td>
                                        <td>{company.Travel.brouchere_link && company.Travel.brouchere_link !== "NA" ? <a href={company.Travel.brouchere_link} target="_black">Click here</a> : "NA"}</td>
                                        <td>{company.Travel.proposal_link && company.Travel.proposal_link !== "NA" ? <a href={company.Travel.proposal_link} target="_black">Click here</a> : "NA"}</td>
                                        <td>{company.Travel.claim_link && company.Travel.claim_link !== "NA" ? <a href={company.Travel.claim_link} target="_black">Click here</a> : "NA"}</td>
                                    </tr>
                                    <tr>
                                        <td>Not Motor Non Health</td>
                                        <td>{company.Non_Motor_Non_Health.policy_link && company.Non_Motor_Non_Health.policy_link !== "NA" ? <a href={company.Non_Motor_Non_Health.policy_link} target="_black">Click here</a> : "NA"}</td>
                                        <td>{company.Non_Motor_Non_Health.brouchere_link && company.Non_Motor_Non_Health.brouchere_link !== "NA" ? <a href={company.Non_Motor_Non_Health.brouchere_link} target="_black">Click here</a> : "NA"}</td>
                                        <td>{company.Non_Motor_Non_Health.proposal_link && company.Non_Motor_Non_Health.proposal_link !== "NA" ? <a href={company.Non_Motor_Non_Health.proposal_link} target="_black">Click here</a> : "NA"}</td>
                                        <td>{company.Non_Motor_Non_Health.claim_link && company.Non_Motor_Non_Health.claim_link !== "NA" ? <a href={company.Non_Motor_Non_Health.claim_link} target="_black">Click here</a> : "NA"}</td>
                                    </tr>
                                </tbody>
                            ))
                        }

                    </table>
                </div>
            </div>
        </div>
    )
}

export default CompanyKnowledgeGuide